  <form [formGroup]="searchForm">
    <app-card>
      <div class="flex gap-4">
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'dashboard.timeseries.missing.dateofwork' | translate }}</label>
            <input appInputDate [defaultDate]="false" formControlName="occurrence">
          </app-input-group>
        </div>
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>Målepunkt ID</label>
            <input type="text" appInput formControlName="meteringPointIdentification" placeholder="Målepunkt ID" />
          </app-input-group>
        </div>
      </div>
      <div class="flex gap-4 align-middle">
        <button appButton (click)="table.search()">
          {{ 'common.search' | translate }}
        </button>
      </div>
    </app-card>
  </form>
  <app-table
    #table
    [config]="lockedTimeseriesTableConfig"
    [(selectedElements)]="selectedElements">
  </app-table>
